<template>
    <div>
        <b-link class="back" @click="goBack"><svg-icon icon="back" /></b-link>
        <template v-if="showBrowserError">
            <h1><b-icon icon="exclamation-circle-fill" variant="danger" scale="1.25" class="mr-2"></b-icon> {{ $t('browser') }}</h1>
            <div class="bg-white rounded p-4 d-flex flex-column align-items-center justify-content-center text-center">
                <p class="mb-0">{{ $t('browserText') }}</p>
            </div>
        </template>
        <div v-else class="mid">
            <h1>{{ $t('permissions') }}</h1>
            <b-list-group>
                <b-list-group-item>
                    <h4>{{ $t('screenCount') }}</h4>
                    <p>{{ $t('screenCountText') }}</p>
                    <div class="d-flex justify-content-between align-items-end">
                        <StatusInfo permission="screens"/>
                        <b-button @click="$emit('screenCheck')" variant="primary" v-if="browserSupported && !$store.state.permissions['screens'] && !pending.screens">{{ $t('screenCountButton') }}</b-button>
                        <b-spinner v-if="browserSupported && pending.screens" variant="primary"></b-spinner>
                    </div>
                </b-list-group-item>
                <b-list-group-item v-if="$store.getters.getCaptureScreens && $store.getters.getAI === false">
                    <h5>{{ $t('capture')}}</h5>
                    <p>{{ $t('captureText') }}</p>
                    <div class="d-flex justify-content-between align-items-end">
                        <StatusInfo permission="capture"/>
                        <b-button @click="$emit('capture')" variant="primary" v-if="browserSupported && !$store.state.permissions['capture'] && !pending.capture">{{ $t('captureButton') }}</b-button>
                        <b-spinner v-if="browserSupported && pending.capture" variant="primary"></b-spinner>
                    </div>
                </b-list-group-item>
                <b-list-group-item v-if="$store.getters.getCapturePhotos || $store.getters.getAI === true">
                    <h5>{{ $t('camera') }}</h5>
                    <p>{{ $store.getters.getAI ? $t('aiCameraText') : $t('cameraText') }}</p>
                    <b-form-select class="mb-4" v-model="cameraInput" v-if="cameras.length > 1" :options="cameras"></b-form-select>
                    <div class="d-flex justify-content-between align-items-end">
                        <StatusInfo permission="camera" :failMessageOverride="cameraFailMessage"/>
                        <b-button @click="$emit('camera')" variant="primary" v-if="browserSupported && !$store.state.permissions['camera'] && !pending.camera">{{ $t('cameraButton') }}</b-button>
                        <b-spinner v-if="browserSupported && pending.camera" variant="primary"></b-spinner>
                    </div>
                    <template v-if="cameraStream">
                        <video class="mt-4 videoPreview" ref="cameraPreview" autoplay muted playsinline></video>
                        <em v-if="$store.getters.getAI === false" class="videoCaption">{{ $t('cameraCentreCaption') }}</em>
                    </template>
                </b-list-group-item>
                <b-list-group-item>
                    <h5>{{ $t('fullscreen') }}</h5>
                    <p>{{ $t('fullscreenText') }}</p>
                    <div class="d-flex justify-content-between align-items-end">
                        <StatusInfo permission="fullscreen"/>
                        <b-button @click="$emit('fullscreen')" variant="primary" v-if="browserSupported && !$store.state.permissions['fullscreen'] && !pending.fullscreen">{{ $t('fullscreenButton') }}</b-button>
                        <b-spinner v-if="browserSupported && pending.fullscreen" variant="primary"></b-spinner>
                    </div>
                </b-list-group-item>
            </b-list-group>
            <b-button class="p-3" block v-if="permissionsStatus" variant="primary" @click="$emit('proceed', whereNext)">{{ $t('continue') }}</b-button>
        </div>
    </div>
</template>
<script>
import StatusInfo from './StatusInfo.vue';
import SvgIcon from '@/components/SvgIcon'
export default {
    name: "AssessmentPermissions",
    components: {
        StatusInfo,
        SvgIcon
    },
    props: {
        permissionsStatus: Boolean,
        cameras: Array,
        selectedCamera: String,
        pending: Object,
        cameraStream: MediaStream,
        cameraFailMessage: {
            type: String,
            default: null,
        }
    },
    data() {
        return {
            cameraInput: null,
            browserReady: false,
        }
    },
    watch: {
        cameras: function(newVal) {
            const nextCamera =
                newVal.find((camera) => camera.value === this.selectedCamera)?.value ||
                (newVal.length ? newVal[0].value : null);
            if (this.cameraInput !== nextCamera) {
                this.cameraInput = nextCamera;
            }
        },
        selectedCamera: function(newVal) {
            if (this.cameraInput !== newVal) {
                this.cameraInput = newVal;
            }
        },
        cameraStream: function(newStream) {
            this.$nextTick(() => {
                if (this.$refs.cameraPreview) {
                    this.$refs.cameraPreview.srcObject = newStream || null;
                }
            });
        },
        cameraInput: function(newVal) {
            if (newVal && newVal !== this.selectedCamera) {
                this.$emit('cameraChange', newVal);
            }
        }
    },
    mounted() {
        this.cameraInput = this.selectedCamera;
        this.$nextTick(() => {
            if (this.$refs.cameraPreview) {
                this.$refs.cameraPreview.srcObject = this.cameraStream || null;
            }
        });
        this.$emit('browser');
        this.$nextTick(() => {
            this.browserReady = true;
        });
    },
    computed: {
        browserSupported() {
            return this.$store.state.permissions.browser;
        },
        showBrowserError() {
            return this.browserReady && !this.browserSupported;
        },
        whereNext() {
            if (this.$store.getters.getAI){
                return 'ai';
            } else if (this.$store.getters.getCaptureScreens) {
                return 'popup';
            } else {
                return 'intro';
            }
        }
    },
    methods: {
        goBack() {
            if (this.$store.getters.getAssessmentAgreement){
                this.$emit('proceed', 'agreement');
            } else {
                this.$router.push('/assessments');
            }
        }
    }
}

</script>
